

export interface CleaverHRForm {
    text: string;
    factor: 'C' | 'D' | 'S' | 'I';
}

export interface DiscModel {
  d: number;
  i: number;
  s: number;
  c: number;
}

export const FORM_DATA: CleaverHRForm[] = [
  { "text": "CONCENTRACION EN TRABAJO A DETALLE", "factor": "C" },
  { "text": "HABILIDAD PARA RESOLVER CONFLICTOS HUMANOS", "factor": "I" },
  { "text": "HABILIDAD PARA TOMAR DECISIONES IMPOPULARES DE LAS TAREAS BAJO SU RESPONSABILIDAD", "factor": "D" },
  { "text": "NECESIDAD DE PERMANECER EN UN MISMO LUGAR DE TRABAJO", "factor": "S" },
  { "text": "PERSISTENCIA PARA TRABAJAR EN FORMA CONTINUA EN TRABAJO DE RUTINA", "factor": "S" },
  { "text": "RITMO Y COORDINACION EN TRABAJO REPETITIVO", "factor": "S" },
  { "text": "HABILIDAD PARA ORGANIZAR DIFERENTES TIPOS DE GENTE", "factor": "I" },
  { "text": "CAPACIDAD PARA HACER FRENTE A INTERRUPCIONES Y CAMBIOS DURANTE EL TRABAJO", "factor": "D" },
  { "text": "NECESIDAD DE SER DIPLOMATICO Y COOPERATIVO", "factor": "C" },
  { "text": "SER CAUTELOSO AL CALCULAR RIESGOS", "factor": "C" },
  { "text": "DECISION PARA ACTUAR SIN PRECEDENTES", "factor": "D" },
  { "text": "PODER MOTIVACIONAL PARA HACER QUE LA GENTE ACTUE", "factor": "I" },
  { "text": "CREATIVIDAD PARA GENERAR NUEVAS IDEAS", "factor": "D" },
  { "text": "HABILIDAD PARA SUPERAR OBJECIONES", "factor": "D" },
  { "text": "HABILIDAD PARA INICIAR RELACIONES CON EXTRAÑOS", "factor": "I" },
  { "text": "VISION PARA PLANEAR A FUTURO EN GRAN ESCALA", "factor": "D" },
  { "text": "CONSTANCIA DE SEGUIR UN PATRON DE TRABAJO ESTABLECIDO", "factor": "S" },
  { "text": "HABILIDAD PARA PERSUADIR A OTROS HACIA NUESTRO PUNTO DE VISTA", "factor": "I" },
  { "text": "NECESIDAD DE TENER AL JEFE DISPONIBLE PARA AYUDAR", "factor": "C" },
  { "text": "CAUTELOSO EN LA TOMA DE DECISIONES QUE PUEDEN SENTAR PRECEDENTE", "factor": "C" },
  { "text": "SEGURIDAD Y DOMINIO DEL IDIOMA PARA EXPRESARSE CON FLUIDEZ", "factor": "I" },
  { "text": "PACIENCIA PARA SEGUIR INSTRUCCIONES DETALLADAS", "factor": "S" },
  { "text": "CAPACIDAD DE SEGUIR UN SISTEMA A LA PERFECCIÓN", "factor": "C" },
  { "text": "SATISFACCION PARA MANTENERSE AL NIVEL DEL PUESTO ACTUAL", "factor": "S" }
]


export interface HumanFactorResponse {
  factor: string,
  description: string,
  _id?: string,
}